<template>
  <section class="xpress-sb-nav-lnk">
    <!-- User -->
    <div class="xpress-user">
      <figure class="user-photo">
        <img :src="user.photo">
      </figure>
      <div class="user-detail">
        <span class="user-role">{{user.role}}</span>
        <span class="user-name">{{user.name}}</span>
      </div>
    </div>
    <!-- ----------------- -->

    <!-- nav links -->

    <!-- dashboard -->
    <div>
      <router-link class="user-dashboard-link" to="/dashboard">
        <span class="icon">
          <icon icon="codicon:home" />
        </span>
        <span class="sb-lnk-name">Dashboard</span>
      </router-link>
    </div>

    <!-- users dropdown -->
    <div
      v-if="showMenu(['001', '012', '013'])"
      :class="[
        'sb-nav-item',
        sbDropdownContent.includes('users')?'dropdown-open users':''
      ]"
    >
      <!-- sidebar dropdown link -->
      <div
        ref="sbDropdownLink"
        :class="[
          'user-dashboard-link sb-dropdown-lnk',
          sbDropdownContent.includes('users')?'sb-dropdown-active':''
        ]"
        :style="sbUserDropdownActiveLink"
        @click="showDropdownContent('users')"
      >
        <span class="icon">
          <icon icon="ph:users-three-light" />
        </span>
        <span class="sb-lnk-name">Users</span>
        <span class="caret">
          <icon icon="ant-design:caret-down-filled" />
        </span>
      </div>
      <!-- sidebar dropdown content -->
      <div class="sb-dropdown-content">
        <div
          v-if="showMenu(['001'])"
        >
          <router-link to="/users/admin-users">Admin Users</router-link>
        </div>
        <div
          v-if="showMenu(['012'])"
        >
          <router-link to="/users/assign-user-department">Assign User Department</router-link>
        </div>
        <div
          v-if="showMenu(['013'])"
        >
          <router-link to="/users/assign-user-privilege">Assign User Privilege</router-link>
        </div>
      </div>
    </div>
    <!-- ------------------ -->

    <!-- merchants -->

    <!-- merchant dropdown -->

    <!-- to be seen by a user assigned the operations
      *** Merchant Management[002]
      *** API Merchant Management[004]
    -->
    <div
      v-if="showMenu(['002'])"
      :class="[
        'sb-nav-item',
        sbDropdownContent.includes('merchants')?'dropdown-open merchants':''
      ]"
    >
      <!-- sidebar dropdown link -->
      <div
        ref="sbDropdownLink"
        :class="[
          'user-dashboard-link sb-dropdown-lnk',
          sbDropdownContent.includes('merchants')?'sb-dropdown-active':''
        ]"
        :style="sbUserDropdownActiveLink"
        @click="showDropdownContent('merchants')"
      >
        <span class="icon">
          <icon icon="ph:users-four-light" />
        </span>
        <span class="sb-lnk-name">Manage Merchants</span>
        <span class="caret">
          <icon icon="ant-design:caret-down-filled" />
        </span>
      </div>

      <!-- sidebar dropdown content -->
      <div class="sb-dropdown-content">
        <div>
          <router-link to="/manage-merchants/merchants">Merchants</router-link>
        </div>

        <div>
          <router-link to="/manage-merchants/api-merchants">API Merchants</router-link>
        </div>
      </div>
    </div>

    <!-- billing accounts -->
    <div
      v-if="showMenu(['004'])"
    >
      <router-link class="user-dashboard-link" to="/billing-accounts">
        <span class="icon">
          <icon icon="feather:credit-card" />
        </span>
        <span class="sb-lnk-name">Billing Accounts</span>
      </router-link>
    </div>

    <!-- transactions dropdown -->
    <div
      v-if="showMenu(['019', '020', '021'])"
      :class="[
        'sb-nav-item',
        sbDropdownContent.includes('transactions')?'dropdown-open users':''
      ]"
    >
      <!-- sidebar dropdown link -->
      <div
        ref="sbDropdownLink"
        :class="[
          'user-dashboard-link sb-dropdown-lnk',
          sbDropdownContent.includes('transactions')?'sb-dropdown-active':''
        ]"
        :style="sbUserDropdownActiveLink"
        @click="showDropdownContent('transactions')"
      >
        <span class="icon">
          <icon icon="ic:twotone-history" />
        </span>
        <span class="sb-lnk-name">Transactions</span>
        <span class="caret">
          <icon icon="ant-design:caret-down-filled" />
        </span>
      </div>
      <!-- sidebar dropdown content -->
      <div class="sb-dropdown-content">
        <div
          v-if="showMenu(['019'])"
        >
          <router-link to="/transactions/transaction-history">Transaction History</router-link>
        </div>
        <div
          v-if="showMenu(['020'])"
        >
          <router-link to="/transactions/transaction-reports">Transaction Reports</router-link>
        </div>
        <div
          v-if="showMenu(['021'])"
        >
          <router-link to="/transactions/transaction-repost-approval">Trans. Repost Approval</router-link>
        </div>
      </div>
    </div>
    <!-- ------------------ -->

    <!-- audit trail -->
    <div
      v-if="showMenu(['019'])"
    >
      <router-link class="user-dashboard-link" to="/audit-trail">
        <span class="icon">
          <icon icon="ant-design:audit-outlined" />
        </span>
        <span class="sb-lnk-name">Audit Trail</span>
      </router-link>
    </div>

    <!-- settings dropdown -->
    <div
      v-if="showMenu(['004', '007', '008', '011', '014'])"
      :class="[
        'sb-nav-item',
        sbDropdownContent.includes('settings')?'dropdown-open settings':''
      ]"
    >
      <!-- sidebar dropdown link -->
      <div
        ref="sbDropdownLink"
        :class="[
          'user-dashboard-link sb-dropdown-lnk',
          sbDropdownContent.includes('settings')?'sb-dropdown-active':''
        ]"
        :style="sbUserDropdownActiveLink"
        @click="showDropdownContent('settings')"
      >
        <span class="icon">
          <icon icon="carbon:settings" />
        </span>
        <span class="sb-lnk-name">Settings</span>
        <span class="caret">
          <icon icon="ant-design:caret-down-filled" />
        </span>
      </div>
      <!-- sidebar dropdown content -->
      <div class="sb-dropdown-content">
        <div
          v-if="showMenu(['011'])"
        >
          <router-link to="/settings/department-registration">Department Registration</router-link>
        </div>
        <div
          v-if="showMenu(['014'])"
        >
          <router-link to="/settings/assign-department-operation">Assign Dept. Operations</router-link>
        </div>
        <div
          v-if="showMenu(['004'])"
        >
          <router-link to="/settings/bank-registration">Bank Registration</router-link>
        </div>
        <div
          v-if="showMenu(['007'])"
        >
          <router-link to="/settings/transaction-charge-management">Transaction Charge Mgt.</router-link>
        </div>
        <div
          v-if="showMenu(['008'])"
        >
          <router-link to="/settings/transaction-processor-management">Transaction Processor</router-link>
        </div>
      </div>
    </div>

    <!-- ------------------- -->
    <div>
      <a @click.prevent="logout" href="/logout" class="user-dashboard-link">
        <span class="icon">
          <icon icon="uiw:logout" />
        </span>
        <span class="sb-lnk-name">Logout</span>
      </a>
    </div>
  </section>
</template>

<script>
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import useConfig from '@/mixins/use-api-config'

import {
  showSidebarMenu as showMenu,
  showPrivilegedAction as showAction
} from '@/utils/userOperationsAndPrivileges'

export default {
  name: 'Administrator Sidebar',
  setup () {
    const store = useStore()
    const { config } = useConfig()

    const userData = computed(() => store.getters['users/_user'])

    const activeDropdown = ref('')
    const sbDropdownLink = ref(null)
    const sbUserDropdownActiveLink = reactive({})
    const sbDepartmentsDropdownActiveLink = reactive({})
    const sbDropdownContent = ref([])

    const user = {
      photo: require('@/assets/img/icons/User.png'),
      name: `${userData?.value?.lastName} ${userData?.value?.firstName}`,
      ...userData.value
    }

    const route = useRoute()

    // const openDropdown = path => {
    const openDropdown = () => {
      if (route.path.includes('/users')) {
        showDropdownContent('users')
      }
      if (route.path.includes('/manage-')) {
        showDropdownContent('merchants')
      }
      if (route.path.includes('/transaction-')) {
        showDropdownContent('transactions')
      }
      if (route.path.includes('/settings')) {
        showDropdownContent('settings')
      }
    }

    const showDropdownContent = dropdownItem => {
      const dropdownOpen = sbDropdownContent.value.includes(dropdownItem)
      if (!dropdownOpen) sbDropdownContent.value.push(dropdownItem)
      else sbDropdownContent.value.splice(sbDropdownContent.value.indexOf(dropdownItem), 1)
    }

    const logout = () => {
      store.dispatch('users/Logout', config)
        .then(() => {
          // route to home
          location.assign('/')
        })
    }

    onBeforeMount(() => openDropdown())

    return {
      user,
      activeDropdown,
      showMenu,
      showAction,
      openDropdown,
      showDropdownContent,
      logout,
      sbDropdownLink,
      sbUserDropdownActiveLink,
      sbDepartmentsDropdownActiveLink,
      sbDropdownContent
    }
  }
}
</script>
